import { graphql } from "gql";

const ADMIN_EDIT_USER_ATTRIBUTE_CATEGORY_MUTATION = graphql(`
  mutation AdminEditUserAttributeCategory(
    $id: ID!
    $input: AdminEditUserAttributeCategoryInput!
  ) {
    adminEditUserAttributeCategory(id: $id, input: $input) {
      ...UserAttributeCategory
    }
  }
`);

export default ADMIN_EDIT_USER_ATTRIBUTE_CATEGORY_MUTATION;
